import * as ActionTypes from "../actions/types";
import {
  mapBanners,
  mapBannersBottom,
  mapBottomBanner,
  mapCarousel,
  mapFooter,
  mapGettingStarted,
} from "../constants/map/banners";

const INITIAL_STATE = {
  frontPageBanners: [],
  frontPageBannersBottom: [],
  footerItems: [],
  getting_started: [
    {
      title: "Browse the available APIs",
      description:
        "<p>Take a look at our APIs to see which one fulfills your use case. Use the API to quickly develop a fully-featured application.</p>",
      link: {
        url: "/apiProducts",
        title: "Explore Our APIs",
        external: false,
      },
    },
    {
      title: "Register",
      description:
        '<p>Did you find your API? Register now to create an account and get started. Maybe you need one of our Partner APIs. Sign <a href="https://files.nbg.gr/developer-portal/NDA%20v2.0.zip">this</a> NDA to become a Partner with NBG.</p>',
      link: {
        url: "",
        title: "",
        external: false,
      },
    },
    {
      title: "Create an application",
      description:
        "<p>Before using the API, you have to create an application. Visit the APPS section, select your organization (or create a new one) and hit the button ADD AN APPLICATION. Follow the instructions and you will get a unique <em>Client ID</em> and <em>Client Secret</em> pair. Check the API documentation for more details on how to use these keys. Remember that you can always invite members to collaborate in your organizations.</p>",
      link: {
        url: "",
        title: "",
        external: false,
      },
    },
    {
      title: "SUBSCRIBE TO AN API",
      description:
        "<p>Now, as your application is registered, you need to subscribe to an API. This step is needed to authorize your application to be able to call an API.</p>",
      link: {
        url: "",
        title: "",
        external: false,
      },
    },
    {
      title: "Test your app",
      description:
        "<p>So, now you’re ready and testing comes into play. Play with your application by using our test environment and build your solution.</p>",
      link: {
        url: "",
        title: "",
        external: false,
      },
    },
    {
      title: "Go Live",
      description:
        "<p>When you feel confident that your app works as intended, you can request production access by contacting us. Upon approval, you will be ready to launch your app to the masses. Good Job!</p>",
      link: {
        url: "/support/contact",
        title: "Contact Us",
        external: false,
      },
    },
    {
      title: "Authorization with OAuth 2.0",
      description:
        "<p>Our APIs use OAuth 2.0 protocol for authentication and authorization. OAuth 2.0 lets you securely authorize your client application to access the data that NBG APIs provide. Note that some of Sandbox APIs do not require OAuth 2.0 authorization. Our intention is to facilitate experimentation and fast application testing. Check the API documentation for details.</p>",
      link: {
        url: "/basicPage/oauth-document",
        title: "OAuth 2.0",
        external: false,
      },
    },
  ],

  bottom_banner: [],
  carousel: [],
  fabs: [],
};

function incFabCount(state, action) {
  const newFab = action.payload;
  const existingFab = state.fabs.find((fab) => fab.id === newFab.id);
  if (!existingFab) {
    state.fabs.push(newFab);
  }
}

function decFabCount(state, action) {
  const oldFab = action.payload;
  const oldPosition = state.fabs.findIndex((fab) => fab.id === oldFab.id);
  if (oldPosition > -1) {
    state.fabs.splice(oldPosition, 1);
  }
}

export const general = {
  initialState: INITIAL_STATE,
  handlers: {
    [ActionTypes.INC_FAB_COUNT]: incFabCount,
    [ActionTypes.DEC_FAB_COUNT]: decFabCount,
  },
};
